<template>
  <div>
    <l-tables
      ref="table"
      :tableConfig="tableConfig"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      :emptyImgSrc="emptyImgSrc"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <div class="search-conditions">
          <a-input
            v-model="keyword"
            @change="search"
            maxlength="30"
            :placeholder="$t('studentManagement.searchPlaceholder')"
            class="search-item"
          >
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img
              class="clear"
              v-if="keyword"
              slot="suffix"
              @click=";(keyword = undefined), search()"
              :src="require('@/assets/icons/icon_gb.png')"
            />
          </a-input>
          <!-- 选择班级 -->
          <div style="position: relative; display: inline-block">
            <a-popover>
              <template slot="content">
                <div class="popover" v-if="selectedClass.length > 0">
                  <span v-for="(item, index) of selectedClass" :key="index">
                    {{ classListFind.find(obj => obj.value == item).label }}
                    <span v-if="index !== selectedClass.length - 1">，</span>
                  </span>
                </div>
              </template>
              <a-select
                style="margin-left: 20px;"
                maxTagCount="1"
                class="search-item"
                mode="multiple"
                v-model="selectedClass"
                :placeholder="$t('studentManagement.selectClass')"
                treeDefaultExpandAll
                @change="handleClassChange"
              >
                <a-select-option v-for="item in classListFind" :key="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-popover>
            <a-icon type="down" style="position: absolute; right: 12px; top: 11px; color: #ccc; font-size: 12px;" />
          </div>
        </div>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('studentManagement.create') }}</a-button>
      </template>
      <template slot="importFile">
        <a-button
          type="primary"
          @click="uploadVisible = true"
          class="import"
          style="margin-right: 10px;background: linear-gradient( 227deg, #72899D 0%, #9BB3C8 100%);"
          >{{ $t('studentManagement.batchImport') }}</a-button
        >
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('studentManagement.create') }}</a-button>
      </template>
      <template #profession="{ record }">
        <span v-if="record.profession">{{ record.profession }}</span>
        <span v-else>--</span>
        <!-- <span v-else>
          <a-cascader
            class="search-item"
            :options="professionList"
            placeholder="请选择专业"
            @change="value => setProfessionChange(value, record.id)"
          >
            <a href="#">请选择专业</a>
          </a-cascader>
        </span> -->
      </template>
      <template #classNames="{ record }">
        <span v-if="record.classNames.length > 0">{{ record.classNames.join(',') }}</span>
        <span v-else>--</span>
      </template>
      <template #studentNumber="{ record }">
        <span v-if="record.studentNumber">{{ record.studentNumber }}</span>
        <span v-else>--</span>
      </template>
      <template #status="{ record }">
        {{ record.status === '1' ? $t('studentManagement.statusEnabled') : $t('studentManagement.statusDisabled') }}
      </template>
    </l-tables>

    <upload-modal
      :visible="uploadVisible"
      :title="$t('studentManagement.importTitle')"
      @upload="handleUpload"
      @cancel="uploadVisible = false"
      @fileChange="handleFileChange"
      @downloadTemplate="downloadTemplate"
    />
    <!-- 导入错误信息 -->
    <a-modal
      class="uploadStu"
      :title="$t('studentManagement.problemStatistics')"
      :visible="infoVisible"
      :footer="null"
      width="800px"
      @cancel="infoVisible = false"
    >
      <a-table :columns="infoColumns" :data-source="infoData">
        <a slot="name" slot-scope="text">{{ text }}</a>
      </a-table>
      <div class="pagination">
        <Pagination
          class="list-pagination"
          :pagination.sync="infoPagination"
          @handleTableChange="handleInofTableChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import UploadModal from '@/components/UploadModal.vue'
import { studentImport, updateTeacherProfession, getAllClassList } from '@/api/admin'
import { getAdminOrgList } from '@/api/lesson'

export default {
  components: {
    LTables,
    UploadModal
  },
  data() {
    return {
      selectedValue: undefined,
      uploadVisible: false,
      teacherFile: null,
      noCreatText: this.$t('studentManagement.noStudent'),
      nullImg: require('@/assets/img/studentNull.png'),
      emptyImgSrc: require('@/assets/img/bj_zanwu_2.png'),
      keyword: undefined,
      selectedProfession: [],
      professionList: [],
      professionSearchList: [],
      roleList: [
        {
          value: '1',
          label: '教师'
        }
      ],
      searchData: {
        keyword: '',
        college_id: '',
        department_id: '',
        professionIds: '',
        classIds: []
      },
      tableConfig: {
        tableName: this.$t('studentManagement.title'),
        tableColumns: [
          {
            title: this.$t('studentManagement.id'),
            dataIndex: 'index',
            key: 'index',
            align: 'center'
          },
          {
            title: this.$t('studentManagement.name'),
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: this.$t('studentManagement.studentNumber'),
            dataIndex: 'studentNumber',
            key: 'studentNumber',
            align: 'center',
            scopedSlots: { customRender: 'studentNumber' }
          },
          {
            title: this.$t('studentManagement.class'),
            dataIndex: 'classNames',
            key: 'classNames',
            align: 'center',
            scopedSlots: { customRender: 'classNames' }
          },
          {
            title: this.$t('studentManagement.status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            scopedSlots: { customRender: 'status' }
          },
          {
            title: this.$t('studentManagement.createdAt'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: '200px',
            align: 'center'
          },
          {
            title: this.$t('studentManagement.operation'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('studentManagement.confirmDelete'),
          content: this.$t('studentManagement.deleteNoRecover')
        },
        tablePort: {
          list: '/student/list',
          del: '/student/delete'
        },
        tableEditRouteNName: 'organizationStudentAdd'
      },
      infoVisible: false,
      infoColumns: [
        {
          title: this.$t('studentManagement.studentName'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: this.$t('studentManagement.studentAccount'),
          dataIndex: 'username',
          key: 'username'
        },
        {
          title: this.$t('studentManagement.problemType'),
          dataIndex: 'type',
          key: 'type'
        },
        {
          title: this.$t('studentManagement.problemDetail'),
          dataIndex: 'message',
          key: 'message'
        }
      ],
      infoData: [],
      infoPagination: {
        page: 1,
        total: 50,
        pageSize: 10,
        hideOnSinglePage: true
      },
      selectedClass: [],
      classSearchList: [],
      classList: [],
      classListFind: []
    }
  },
  methods: {
    search() {
      this.searchData.keyword = this.keyword
    },
    handleTableHeaderChange([filters, getList]) {
      getList()
    },
    create() {
      this.$router.push({
        name: 'organizationStudentAdd'
      })
    },
    handleFileChange(file) {
      this.teacherFile = file
    },
    handleUpload() {
      if (!this.teacherFile) {
        this.$message.error(this.$t('studentManagement.uploadRequired'))
        return
      }
      console.log(this.teacherFile)
      const formData = new FormData()
      formData.append('file', this.teacherFile)

      studentImport(formData).then(res => {
        if (res.code !== 200) return
        const data = res.data.data || []
        this.uploadVisible = false
        if (data.length > 0) {
          this.infoVisible = true
          this.originalData = data
          this.infoData = data.slice(0, 10)
          this.infoPagination.total = data.length
        } else {
          this.$message.success(this.$t('studentManagement.importSuccess'))
          this.$refs.table.getList()
        }
      })
    },
    downloadTemplate() {
      location.href = '/static/xlsx/学生导入模版.xlsx'
      // fetch('/static/xlsx/学生导入模版.xlsx', {
      //   method: 'GET'
      // })
      //   .then(res => res.blob())
      //   .then(blob => {
      //     const url = window.URL.createObjectURL(blob);
      //     const a = document.createElement('a');
      //     a.href = url;
      //     a.download = '学生导入模版.xlsx';
      //     document.body.appendChild(a);
      //     a.click();
      //     a.remove();
      //     window.URL.revokeObjectURL(url);
      //   });
    },
    getProfessionList() {
      getAdminOrgList().then(res => {
        if (res.code === 200) {
          this.professionListFind = []
          for (let item of res.data.list) {
            this.professionList.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  children: items.child.map(itemt => {
                    return {
                      value: itemt.id,
                      label: itemt.name,
                      isLeaf: true
                    }
                  })
                }
              })
            })
            this.professionSearchList.push({
              value: item.id,
              label: item.name,
              disabled: true,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  disabled: true,
                  children: items.child.map(itemt => {
                    this.professionListFind.push({
                      value: itemt.id,
                      label: itemt.name
                    })
                    return {
                      value: itemt.id,
                      label: itemt.name,
                      isLeaf: true
                    }
                  })
                }
              })
            })
          }
        }
      })
    },
    handleProfessionChange(value) {
      console.log(value)
      this.searchData.professionIds = value
      this.search()
    },
    resetSearch() {
      this.keyword = undefined
      this.selectedProfession = []
      this.searchData = {
        keyword: '',
        college_id: '',
        department_id: '',
        professionIds: ''
      }
      this.search()
    },
    async setProfessionChange(value, id) {
      try {
        const res = await updateTeacherProfession({
          id,
          collegeId: value[0],
          departmentId: value[1],
          professionId: value[2]
        })
        if (res.code == 200) {
          this.$message.success(this.$t('studentManagement.updateProfessionSuccess'))
          this.$refs.table.getList()
        }
      } catch (error) {
        console.error('更新专业失败:', error)
        this.$message.error(this.$t('studentManagement.updateProfessionFailed'))
      }
    },
    async setRoleChange(value, id) {
      try {
        await updateTeacherRole({
          id,
          roleId: value[0]
        })
        this.$message.success(this.$t('studentManagement.updateRoleSuccess'))
        this.search()
      } catch (error) {
        this.$message.error(this.$t('studentManagement.updateRoleFailed'))
      }
    },
    handleInofTableChange() {
      const startIndex = (this.infoPagination.page - 1) * this.infoPagination.pageSize
      const endIndex = startIndex + this.infoPagination.pageSize
      this.infoData = this.originalData.slice(startIndex, endIndex)
    },
    handleClassChange(value) {
      console.log(value)
      this.searchData.classIds = value
      this.search()
    },
    async getClassList() {
      try {
        this.classListFind = []
        const res = await getAllClassList()
        if (res.code === 200) {
          this.classListFind = res.data.list.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        }
      } catch (error) {
        console.error(this.$t('studentManagement.getClassListFailed'), error)
      }
    }
  },
  mounted() {
    this.getProfessionList()
    this.getClassList()
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-select-selection--multiple {
  border-radius: 20px;
}
</style>
